<template>
  <div>
    <validation-provider
      :name="$t(config.name)"
      :rules="showFromAlarm ? 'required' : config.rules"
      v-slot="{ errors }"
    >
      <label class="d-block">
        {{ $t(config.name) }}
      </label>
      <v-select
        v-if="!loading"
        v-model="model.command"
        :options="itemsOptions"
        :clearable="true"
        :reduce="(val) => val.value"
        input-id="alarm_panel_id"
        :multiple="multiple"
        @option:selected="onOptionSelected"
        @input="onCommandInput"
      />
      <p v-if="config.hint" class="mb-0 small">{{ $t(config.hint) }}</p>
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
    <hr class="mb-2"/>
    <node-data
      :key="model.command || 'empty-command'"
      v-model="model.data"
      :node-info="nodeInfo"
      :requirements="requirements"
      :flowchart-config="context.flowchartConfig"
    />
  </div>
</template>

<script>
import vSelect from "vue-select";
import axios from "@/libs/axios";
import {ValidationProvider} from "vee-validate";

export default {
  name: "ConfigField",
  components: {
    ValidationProvider,
    vSelect,
    NodeData: () => import("./index.vue"),
  },
  props: {
    value: {
      type: [Array, Object],
      default: () => ({}),
    },
    multiple: Boolean | Number,
    config: Object,
    context: Object,
    nodeInfo: {
      type: Object,
      default: () => ({}),
    },
    nodeConfig: Object,
  },
  data() {
    return {
      model: null,
      fromAlarm: false,
      showFromAlarm: false,
      loading: true,
      items: [],
      options: [],
      requirements: [],
    };
  },
  created() {
    this.showFromAlarm = this.context.flowchartConfig.alarm_compatible;
    this.model = this.normalizeModel(this.value);
  },
  async mounted() {
    await this.fetchCommands();
    if (this.model.command) {
      this.$nextTick(() => {
        const cmd = this.items.find((item) => item.value === this.model.command);
        if (cmd) this.requirements = cmd.requirements;
      });
    }

    this.$emit("input", this.model);
  },
  watch: {
    model: {
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    itemsOptions() {
      if (this.options.length) {
        return this.options;
      }

      this.options = [...this.items];

      return this.options;
    },
  },
  methods: {
    isPlainObject(value) {
      return value !== null && typeof value === "object" && !Array.isArray(value);
    },
    normalizeModel(value) {
      const model = this.isPlainObject(value) ? {...value} : {};
      model.data = this.isPlainObject(model.data) ? {...model.data} : {};

      return model;
    },
    async fetchCommands() {
      this.items = [];
      this.loading = true;

      const group = this.nodeInfo.command === 'activate-device-output'
        ? 'activation'
        : 'deactivation';

      const {data} = await axios.get(`/v1/services/commands?group=${group}`);
      this.items = data.data.map((item) => ({
        value: item.cmd,
        label: this.$t(`commands.list.${item.name}.name`),
        requirements: item.requirements,
      }));

      this.loading = false;
    },
    onCommandInput(command) {
      if (!command) {
        this.requirements = [];
        this.$set(this.model, "data", {});
      }
    },
    onOptionSelected(selected) {
      this.requirements = selected.requirements;
      this.$set(this.model, "data", {});
    },
  },
};

</script>

<style scoped lang="scss">

</style>
